import React from 'react';
import styled from 'styled-components';
import QuickLinkMenu from './StaticSection/QuickLinkMenu';
import DynamicMenu from './DynamicSection/DynamicMenu';
import Branding from './items/Branding';

export const HeaderContainer = styled.header`
  background-color: ${({ theme }) => theme.colors.Nordic};
  padding-left: 1rem;
  padding-right: 1rem;
`;

export const HeaderItems = styled.div`
  display: flex;
  height: 3rem;
  align-items: center;
`;

export const LeftSectionContainer = styled.div`
  flex: 1;
`;

export const RightSectionContainer = styled.div`
  flex: none;
`;
export const LeftSectionLayout = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SeperatorBox = styled.div`
  width: 0.1rem;
  height: 1.5rem;
  background-color: ${({ theme }) => theme.colors.Tarpon};
`;

const LeftSectionView = () => {
  return (
    <LeftSectionLayout>
      <Branding />
      <SeperatorBox />
      <DynamicMenu />
    </LeftSectionLayout>
  );
};

const Header = () => {
  return (
    <HeaderContainer>
      <HeaderItems>
        <LeftSectionContainer>
          <LeftSectionView />
        </LeftSectionContainer>
        <RightSectionContainer>
          <QuickLinkMenu />
        </RightSectionContainer>
      </HeaderItems>
    </HeaderContainer>
  );
};

export default Header;
